import { InjectionToken } from '@angular/core';

export const APP_SVG_ICON_PATH = new InjectionToken<string>('Svg icon path');
